/* Black Friday: aftelling in de banner, op de collectiepagina en in de balk. Na de einddatum verdwijnt hij. */
(() => {
  const end = Date.parse(document.body && document.body.dataset.bfEnd || '');
  if (!end) return;
  const pad = (n) => String(n).padStart(2, '0');
  function tick() {
    const ms = end - Date.now();
    if (ms <= 0) {
      document.querySelectorAll('[data-bf-count]').forEach((el) => { el.hidden = true; });
      document.querySelectorAll('[data-bf-left]').forEach((el) => { el.textContent = 'laatste kans'; });
      return false;
    }
    const d = Math.floor(ms / 864e5), h = Math.floor((ms % 864e5) / 36e5), m = Math.floor((ms % 36e5) / 6e4);
    document.querySelectorAll('[data-bf-count]').forEach((el) => {
      const set = (u, v) => { const b = el.querySelector('[data-u="' + u + '"]'); if (b) b.textContent = v; };
      set('d', d); set('h', pad(h)); set('m', pad(m));
    });
    document.querySelectorAll('[data-bf-left]').forEach((el) => {
      el.textContent = d > 1 ? 'nog ' + d + ' dagen' : d === 1 ? 'nog 1 dag' : 'nog ' + Math.max(h, 1) + ' uur';
    });
    return true;
  }
  if (tick()) setInterval(tick, 30000);
})();
